import GridTable from '@/components/table/GridTable'
import { HStack } from '@musinsa/mwms-ds'
import { HistoryUserLogItem } from '@/services/history/history.types'
import { PAGE_SIZE_ON_HISTORY } from '@/services/history/useHistoryQuries'
import { COLUMN_WIDTH } from '@/utils/grid/grid'
import { ColDef } from 'ag-grid-community'

interface UserLogTableProps {
  data: HistoryUserLogItem[]
  isLoading?: boolean
}
export const UserLogTable = ({ data, isLoading }: UserLogTableProps) => {
  const columnDefs: ColDef<HistoryUserLogItem>[] = [
    { field: 'email', headerName: '이메일', width: COLUMN_WIDTH.tinyText },
    { field: 'authCd', headerName: '권한', width: COLUMN_WIDTH.status },
    { field: 'evtDate', headerName: '날짜', cellDataType: 'dateNday', width: COLUMN_WIDTH.date },
    { field: 'evtTime', headerName: '시간', cellDataType: 'time', width: COLUMN_WIDTH.time },
    { field: 'accUrl', headerName: 'ip', width: COLUMN_WIDTH.status },
    { field: 'menuCd', headerName: '메뉴코드', width: COLUMN_WIDTH.status },
    { field: 'actTyp', headerName: '활동유형', width: COLUMN_WIDTH.status },
    { field: 'params', headerName: '파라미터', width: COLUMN_WIDTH.text },
    { field: 'orgData', headerName: '변경 전 데이터', width: COLUMN_WIDTH.tinyText },
    { field: 'curData', headerName: '변경 후 데이터', width: COLUMN_WIDTH.tinyText },
    { field: 'remark', headerName: 'remark', width: COLUMN_WIDTH.tinyText },
  ]

  return (
    <HStack full gap={16}>
      <GridTable<HistoryUserLogItem>
        gridKey="HS01_HEAD"
        rowData={data}
        isLoading={isLoading}
        countPerPage={PAGE_SIZE_ON_HISTORY}
        columnDefs={columnDefs}
        totalCount={data.length}
        useColumnNo
        useColumnFilter
      />
    </HStack>
  )
}
